import appStore from 'store';
import api from './api';

const store = {
    namespaced: true,
    state:{
        advertTotal:0,
        advertInfo:[],
        feeTotal:0,
        feeInfo:[]
    },
    mutations:{
        setAdvertTotal(state,payload){
            state.advertTotal = payload;
        },
        setAdvertInfo(state,payload){
            state.advertInfo = payload;
        },
        setFeeTotal(state,payload){
            state.feeTotal = payload;
        },
        setFeeInfo(state,payload){
            state.feeInfo = payload;
        }
    },
    actions:{
        findAdvertInfo({commit},data){
            api.advertQuery(data).then(response =>{
                commit('setAdvertTotal',response.data.totalCount);
                commit('setAdvertInfo',response.data.list);
            })
        },

        findFeeInfo({commit},data){
            api.feeQuery(data).then(response =>{
                commit('setFeeTotal',response.data.totalCount);
                commit('setFeeInfo',response.data.list);
            })
        }
    }
}

appStore.registerModule('otcConfig', store);